import { render } from "./mobile_nav.vue?vue&type=template&id=96bb09a0"
import script from "./mobile_nav.js?vue&type=script&lang=js"
export * from "./mobile_nav.js?vue&type=script&lang=js"

import "./mobile_nav.vue?vue&type=style&index=0&id=96bb09a0&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__